import { Action } from "@ngrx/store";
import { LexiconTab } from "../model";
import { LexiconSchema } from "./lexicon-sentiment-tuning.model";

export enum LexiconSentimentTuningActionTypes {
  ResetLexiconSentimentTuning = "[LexiconSentimentTuning] Reset Lexicon Sentiment Tuning",
  InitLexiconSentimentTuning = "[LexiconSentimentTuning] Init Lexicon Sentiment Tuning",

  LoadLexiconSentimentConfig = "[LexiconSentimentTuning] Load Lexicon Sentiment Config",
  SetLexiconConfig = "[LexiconSentimentTuning] Load Lexicon Sentiment Config Success",
  LoadLexiconSentimentConfigFailure = "[LexiconSentimentTuning] Load Lexicon Sentiment Config Failure",
  AddNewLexicon = "[LexiconSentimentTuning] Add New Lexicon",
  DeleteLexiconRecord = "[LexiconSentimentTuning] Delete Lexicon Record",
  UpdateLexiconRecord = "[LexiconSentimentTuning] Update Lexicon Record",
}

export class ResetLexiconSentimentTuning implements Action {
  readonly type = LexiconSentimentTuningActionTypes.ResetLexiconSentimentTuning;

  constructor() {}
}

export class InitLexiconSentimentTuning implements Action {
  readonly type = LexiconSentimentTuningActionTypes.InitLexiconSentimentTuning;

  constructor(
    public lexiconSentimentID: string,
    public lexiconConfig: Object,
  ) {}
}

export class LoadLexiconSentimentConfig implements Action {
  readonly type = LexiconSentimentTuningActionTypes.LoadLexiconSentimentConfig;

  constructor(public lexiconSchemaID: string) {}
}

export class SetLexiconConfig implements Action {
  readonly type = LexiconSentimentTuningActionTypes.SetLexiconConfig;

  constructor(public lexiconConfig: LexiconSchema) {}
}

export class LoadLexiconSentimentConfigFailure implements Action {
  readonly type =
    LexiconSentimentTuningActionTypes.LoadLexiconSentimentConfigFailure;

  constructor(public payload: { error: any }) {}
}

export class AddNewLexicon implements Action {
  readonly type = LexiconSentimentTuningActionTypes.AddNewLexicon;

  constructor(
    public lexiconId: string,
    public selectedTab: LexiconTab,
    public word: string,
    public value: number | string,
  ) {}
}

export class DeleteLexiconRecord implements Action {
  readonly type = LexiconSentimentTuningActionTypes.DeleteLexiconRecord;

  constructor(
    public lexiconId: string,
    public selectedTab: LexiconTab,
    public word: string,
  ) {}
}

export class UpdateLexiconRecord implements Action {
  readonly type = LexiconSentimentTuningActionTypes.UpdateLexiconRecord;

  constructor(
    public lexiconId: string,
    public selectedTab: LexiconTab,
    public word: string,
    public value: number | string,
    public originalWord: string,
  ) {}
}

export type LexiconSentimentTuningAction =
  | ResetLexiconSentimentTuning
  | InitLexiconSentimentTuning
  | LoadLexiconSentimentConfig
  | SetLexiconConfig
  | LoadLexiconSentimentConfigFailure
  | AddNewLexicon
  | DeleteLexiconRecord
  | UpdateLexiconRecord;
